import { jsxs as t, jsx as o } from "react/jsx-runtime";
import r from "../../assets/calendar.svg.js";
import e from "../../assets/time.svg.js";
import { styled as i } from "@mui/joy";
import m from "@mui/joy/Stack";
import s from "@mui/joy/Typography";
import { formatDate as a, TIME_FORMAT as n } from "../../common/utils/formatDate.js";
const l = i(s)(({ theme: t2 }) => ({ fontSize: t2.fontSize.sm, fontWeight: 600 })), c = ({ value: i2, onlyDate: s2, withoutIcons: c2, dateIcon: f = r, timeIcon: u = e }) => {
  if (!i2) return "-";
  const p = { width: 16, height: 16 };
  return t(m, { direction: "row", gap: 1, sx: { svg: { fill: (t2) => t2.palette.neutral[700] } }, children: [o(l, { startDecorator: !f || c2 ? null : o(f, { style: p }), children: a(i2) }), !s2 && o(l, { startDecorator: !u || c2 ? null : o(u, { style: p }), children: a(i2, n) })] });
};
export {
  c as FormatDateTime,
  c as default
};
//# sourceMappingURL=FormatDateTime.js.map
